function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Avatar, Badge, Box, HStack, Icon, IconButton, Link, Portal, Stack, Td, Text, Tr } from '@chakra-ui/react';
import { faGripVertical, faMusic, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
export function SongDescription(param) {
    var song = param.song, titleProps = param.titleProps, descriptionProps = param.descriptionProps, _param_isDraggable = param.isDraggable, isDraggable = _param_isDraggable === void 0 ? false : _param_isDraggable;
    var _titleProps_color, _titleProps_color1;
    return /*#__PURE__*/ _jsxs(HStack, {
        spacing: 4,
        lineHeight: 1.25,
        userSelect: "none",
        width: "100%",
        alignItems: "center",
        isTruncated: true,
        role: "group",
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                width: "20px",
                height: "20px",
                placeItems: "center",
                display: isDraggable || '_position' in song ? 'grid' : 'none',
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        color: (_titleProps_color = titleProps === null || titleProps === void 0 ? void 0 : titleProps.color) !== null && _titleProps_color !== void 0 ? _titleProps_color : 'textSecondary',
                        display: "none",
                        as: FontAwesomeIcon,
                        icon: faGripVertical,
                        _groupHover: {
                            display: isDraggable ? 'block' : 'none'
                        }
                    }),
                    '_position' in song ? /*#__PURE__*/ _jsx(Badge, {
                        size: "sm",
                        variant: "solid",
                        color: (_titleProps_color1 = titleProps === null || titleProps === void 0 ? void 0 : titleProps.color) !== null && _titleProps_color1 !== void 0 ? _titleProps_color1 : 'textPrimary',
                        _light: {
                            backgroundColor: 'blackAlpha.200'
                        },
                        _dark: {
                            backgroundColor: 'whiteAlpha.300'
                        },
                        _groupHover: {
                            display: isDraggable ? 'none' : 'block'
                        },
                        children: song._position
                    }) : null
                ]
            }),
            /*#__PURE__*/ _jsx(Avatar, {
                src: song.track.artistAvatarUrl,
                size: "sm",
                borderRadius: "md",
                icon: /*#__PURE__*/ _jsx(Icon, {
                    as: FontAwesomeIcon,
                    icon: faMusic
                })
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                spacing: 1,
                isTruncated: true,
                children: [
                    /*#__PURE__*/ _jsx(Link, _object_spread_props(_object_spread({
                        fontWeight: 600,
                        cursor: "pointer",
                        href: song.track.url,
                        color: "textPrimary",
                        isTruncated: true,
                        isExternal: true
                    }, titleProps), {
                        children: song.track.title
                    })),
                    /*#__PURE__*/ _jsxs(Text, _object_spread_props(_object_spread({
                        isTruncated: true,
                        lineHeight: 1,
                        fontSize: "sm"
                    }, descriptionProps), {
                        children: [
                            song.track.artist,
                            " • ",
                            dayjs.duration(song.track.duration, 'seconds').format('mm:ss')
                        ]
                    }))
                ]
            })
        ]
    });
}
function SongRow(_param) {
    var song = _param.song, snapshot = _param.snapshot, provided = _param.provided, portalRef = _param.portalRef, _param_isDraggable = _param.isDraggable, isDraggable = _param_isDraggable === void 0 ? false : _param_isDraggable, _param_showRequester = _param.showRequester, showRequester = _param_showRequester === void 0 ? true : _param_showRequester, onDelete = _param.onDelete, props = _object_without_properties(_param, [
        "song",
        "snapshot",
        "provided",
        "portalRef",
        "isDraggable",
        "showRequester",
        "onDelete"
    ]);
    var intl = useIntl();
    if (isDraggable && portalRef != null && (snapshot === null || snapshot === void 0 ? void 0 : snapshot.isDragging) != null && snapshot.isDragging) {
        var _provided_draggableProps, _provided_dragHandleProps, _provided_innerRef;
        return /*#__PURE__*/ _jsx(Portal, {
            containerRef: portalRef,
            children: /*#__PURE__*/ _jsx(Tr, _object_spread_props(_object_spread(_object_spread_props(_object_spread({
                maxWidth: "600px",
                isTruncated: true
            }, (_provided_draggableProps = provided === null || provided === void 0 ? void 0 : provided.draggableProps) !== null && _provided_draggableProps !== void 0 ? _provided_draggableProps : {}, (_provided_dragHandleProps = provided === null || provided === void 0 ? void 0 : provided.dragHandleProps) !== null && _provided_dragHandleProps !== void 0 ? _provided_dragHandleProps : {}), {
                ref: (_provided_innerRef = provided === null || provided === void 0 ? void 0 : provided.innerRef) !== null && _provided_innerRef !== void 0 ? _provided_innerRef : undefined,
                paddingY: 4,
                paddingX: 6,
                borderWidth: 1,
                borderColor: "borderSecondary",
                backgroundColor: "backgroundActive",
                boxShadow: "outline",
                borderRadius: "md"
            }), props), {
                children: /*#__PURE__*/ _jsx(SongDescription, {
                    isDraggable: true,
                    song: song,
                    titleProps: {
                        color: 'textAccent'
                    },
                    descriptionProps: {
                        color: 'textAccent'
                    }
                })
            }))
        });
    }
    var _provided_draggableProps1;
    return /*#__PURE__*/ _jsxs(Tr, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, (_provided_draggableProps1 = provided === null || provided === void 0 ? void 0 : provided.draggableProps) !== null && _provided_draggableProps1 !== void 0 ? _provided_draggableProps1 : {}), {
        borderBottomWidth: 1,
        borderColor: "borderSecondary",
        backgroundColor: "backgroundPrimary"
    }), props), {
        children: [
            /*#__PURE__*/ _jsx(Td, _object_spread_props(_object_spread({
                ref: provided === null || provided === void 0 ? void 0 : provided.innerRef
            }, provided === null || provided === void 0 ? void 0 : provided.dragHandleProps), {
                role: "group",
                maxWidth: "1px",
                textOverflow: "ellipsis",
                children: /*#__PURE__*/ _jsx(SongDescription, {
                    song: song,
                    isDraggable: isDraggable
                })
            })),
            /*#__PURE__*/ _jsx(Td, {
                display: {
                    base: 'none',
                    md: 'table-cell'
                },
                children: /*#__PURE__*/ _jsxs(Stack, {
                    spacing: 0,
                    isTruncated: true,
                    textAlign: "left",
                    width: "1px",
                    display: "table-cell",
                    children: [
                        showRequester ? /*#__PURE__*/ _jsx(Text, {
                            fontWeight: 600,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            children: 'user' in song ? song.user.displayName : intl.formatMessage({
                                id: "bv2dU7",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Playlist"
                                    }
                                ]
                            })
                        }) : /*#__PURE__*/ _jsx(Text, {
                            fontWeight: 600,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            children: dayjs(song.createdAt).format('MMM D, YYYY')
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "sm",
                            color: "textSecondary",
                            children: dayjs(song.createdAt).fromNow()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Td, {
                textAlign: "right",
                width: "1px",
                children: onDelete !== undefined ? /*#__PURE__*/ _jsx(IconButton, {
                    size: "xs",
                    variant: "ghost",
                    isDisabled: onDelete == null,
                    onClick: function() {
                        return onDelete === null || onDelete === void 0 ? void 0 : onDelete(song);
                    },
                    icon: /*#__PURE__*/ _jsx(Icon, {
                        as: FontAwesomeIcon,
                        icon: faTrash
                    }),
                    "aria-label": intl.formatMessage({
                        id: "QXORRO",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Delete Song"
                            }
                        ]
                    })
                }) : null
            })
        ]
    }));
}
export default SongRow;
